import actionTypes from 'src/modules/redux/actionTypes'

export const resetProfileInfo = () => ({
  type: actionTypes.RESET_PROFILE_INFO
})
